/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const NotInDigestMultibase: core.serialization.ObjectSchema<
    serializers.NotInDigestMultibase.Raw,
    Truvity.NotInDigestMultibase
> = core.serialization.object({
    values: core.serialization.list(core.serialization.string()),
});

export declare namespace NotInDigestMultibase {
    export interface Raw {
        values: string[];
    }
}
